import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref } from 'vue'
import { AppSettings, AppSettingsService } from '@prodcard/core'
import AppSettingsForm from './AppSettingsForm.vue'
import { callSuccessToast, createCtx, handleError } from '../../../helpers'
import { cloneDeep } from 'lodash'
import { CardHeader } from '../../../components'


export default /*#__PURE__*/_defineComponent({
  __name: 'AppSettingsEditPage',
  props: {
    appSettingsService: {}
  },
  setup(__props: any) {

const props = __props;



const appSettings = ref<AppSettings | undefined>(undefined)
const loading = ref(false)
const saving = ref(false)

const submit = (opts: AppSettings) =>
  handleError(async () => {
    await props.appSettingsService.save(createCtx(), cloneDeep(opts))
    callSuccessToast('Настройки сохранены')
  }, saving)

handleError(async () => {
  appSettings.value = await props.appSettingsService.load(createCtx())
}, loading)

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, { cols: "12" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, { loading: loading.value }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, { class: "pa-0" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(CardHeader), null, {
                    title: _withCtx(() => [
                      _createTextVNode("Системные настройки")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_text, { class: "mt-8 pa-0" }, {
                default: _withCtx(() => [
                  (appSettings.value && !loading.value)
                    ? (_openBlock(), _createBlock(AppSettingsForm, {
                        key: 0,
                        settings: appSettings.value,
                        loading: loading.value,
                        saving: saving.value,
                        onOnSubmit: submit
                      }, null, 8, ["settings", "loading", "saving"]))
                    : (_openBlock(), _createBlock(_component_v_skeleton_loader, {
                        key: 1,
                        type: "heading@8, actions"
                      }))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["loading"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})